import { Injectable, NgZone, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { MBService } from './msg_box.service';

@Injectable({
  providedIn: 'root'
})
export class InactivityService implements OnDestroy {
  private timeoutId: any;
  private readonly TIMEOUT_MS = 300000; // 5 minutos

  constructor(
    private router: Router,
    private authService: AuthService,
    private msgBox: MBService,
    private ngZone: NgZone,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  start(): void {
    this.setupListeners();
    this.resetTimer();
  }

  private setupListeners(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.ngZone.runOutsideAngular(() => {
        window.addEventListener('mousemove', this.resetTimer);
        window.addEventListener('mousedown', this.resetTimer);
        window.addEventListener('keypress', this.resetTimer);
        window.addEventListener('touchmove', this.resetTimer);
      });
    }
  }

  private removeListeners(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.removeEventListener('mousemove', this.resetTimer);
      window.removeEventListener('mousedown', this.resetTimer);
      window.removeEventListener('keypress', this.resetTimer);
      window.removeEventListener('touchmove', this.resetTimer);
    }
  }

  private resetTimer = (): void => {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    
    // Solo correr el timeout fuera de angular para no sobrecargar el change detection
    this.ngZone.runOutsideAngular(() => {
      this.timeoutId = setTimeout(() => this.logout(), this.TIMEOUT_MS);
    });
  }

  private logout(): void {
    this.ngZone.run(() => {
      if (this.authService.currentUserValue) {
        this.authService.logout();
        this.msgBox.Notificar('Su sesión se ha cerrado por inactividad');
      }
    });
  }

  ngOnDestroy(): void {
    this.removeListeners();
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }
}
